import { createReducer } from '@reduxjs/toolkit';
import { handleActionStart, handleActionError } from 'store/utils';
import {
  fetchDiseases,
  setCurrentPatient,
  clearCurrentPatient,
  updateCovidCohort,
} from 'store/currentPatient/actions';

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [fetchDiseases.STARTED]: handleActionStart,
  [fetchDiseases.SUCCEEDED]: (state, action) => {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload.data.diseasesEvidence;
  },
  [fetchDiseases.FAILED]: handleActionError,
  [setCurrentPatient]: (_, action) => action.payload.diseasesEvidence,
  [clearCurrentPatient]: () => initialState,
  [updateCovidCohort]: (state, action) => {
    state.data.additionalInfo['covid 19'].user_cohort = action.payload;
  },
});
